import React from 'react';
import Navbar from './Navbar';
import { Hidden } from '@material-ui/core';
import Cajon from './Cajon';
import Horas from '../pages/Horas';


const ContenedorHoras = () => {
    
    const [abrir, setAbrir] = React.useState(false)

    const accionAbrir = () => {
        setAbrir(!abrir)
    }

    return (
        <div>
            <Navbar accionAbrir={accionAbrir} />
            <Hidden xsDown>
                <Cajon
                    variant="permanent"
                    open={true}
                />
            </Hidden>
            <Hidden smUp>
                <Cajon
                    variant="temporary"
                    open={abrir}
                    onClose={accionAbrir}
                />
            </Hidden>
            <div>
               <Horas />
            </div>
        </div>
    )
}

export default ContenedorHoras;
